import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../styles/Partners.scss';
import Title from './common/Title';
import SliderNavigation from './common/SliderNavigation';

const PartnersSkeleton = () => {
  return (
    <section className="partners">
      <Title text="OUR PARTNERS" />

      <div className="partners-slider">
        <SliderNavigation
          onPrevClick={() => {}}
          onNextClick={() => {}}
          canPrev={false}
          canNext={false}
        />

        <div className="partners-container">
          <div className="partners-track">
            {Array.from({ length: 5 }).map((_, idx) => (
              <div key={idx} className="partner-item">
                <Skeleton height={100} width={200} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSkeleton;
